/* Suparno Karmakar */
import React from 'react';
import MenuItems from './MenuItems/MenuItems';

export default function Menu(props){
    return (
        <section className='Menu'>
            <MenuItems/>
        </section>
    )
}